import type { MetaFunction } from 'react-router'
import HomePage from '~/pages/HomePage.jsx'

export const meta: MetaFunction = () => [
  { title: 'S.J.S. Technology — Digital Printing Machines, Bengaluru' },
  {
    name: 'description',
    content:
      'S.J.S. Technology, Bengaluru — VICTORY digital printing machines, VisionJet inks, installation & 24/7 service support for signage, textile & packaging printing.',
  },
  { property: 'og:type', content: 'website' },
  { property: 'og:title', content: 'S.J.S. Technology — Digital Printing Machines, Bengaluru' },
  {
    property: 'og:description',
    content:
      'VICTORY digital printing machines, VisionJet inks, installation & 24/7 service support.',
  },
  { property: 'og:url', content: 'https://sjstechnology.in/' },
  { property: 'og:image', content: 'https://sjstechnology.in/s_logo_transparent.webp' },
  { name: 'twitter:card', content: 'summary_large_image' },
]

export default function Index() {
  return <HomePage />
}
